<template>
    <div class="d-flex">
        <div id="soap-loading-menu">
            <loader />
        </div>
        <div id="soap-loading-menu-divider"></div>
        <div id="soap-loading-content">
            <loader />
        </div>
    </div>
</template>
<script>
import Loader from "@/components/elements/loader-list";
export default {
    components: {
        Loader
    }
};
</script>
<style scoped>
@media (max-width: 768px) {
    #soap-loading-menu {
        display: none;
    }

    #soap-loading-menu-divider {
        display: none;
    }
}

#soap-loading-menu {
    width: 250px;
}

#soap-loading-menu-divider {
    width: 30px;
}

#soap-loading-content {
    flex: 1;
}
</style>
